import React from 'react';
import { connect } from 'react-redux';
import Model from '../utils/model';
import ObjectEditor from '../components/value/object-editor';

class Form extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.isLoading = this.isLoading.bind(this);
    }

    onChange(propertyId, objectEditorData) {
        manywho.state.setComponent(this.props.id, { objectData: Model.toModel(objectEditorData) }, this.props.flowKey, false);
        this.setState({ objectData: objectEditorData });
    }

    isLoading(loading) {
        manywho.state.setComponentLoading(this.props.id, loading && {}, this.props.flowKey);
        this.forceUpdate();
    }

    componentWillMount() {
        if (this.props.isDesignTime)
            return;

        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const typeProperties = manywho.utils.getObjectDataProperty(model.tags[0].objectData[0].properties, 'Properties').objectData;

        this.setState({
            type: {
                developerName: manywho.utils.getObjectDataProperty(model.tags[0].objectData[0].properties, 'DeveloperName').contentValue,
                typeElementId: manywho.utils.getObjectDataProperty(model.tags[0].objectData[0].properties, 'Id').contentValue,
                properties: new Map(typeProperties.map((typeProperty) => {
                    const id = manywho.utils.getObjectDataProperty(typeProperty.properties, 'Id').contentValue
                    return [
                        id,
                        {
                            contentType: manywho.utils.getObjectDataProperty(typeProperty.properties, 'ContentType').contentValue,
                            contentFormat: manywho.utils.getObjectDataProperty(typeProperty.properties, 'ContentFormat').contentValue,
                            developerName: manywho.utils.getObjectDataProperty(typeProperty.properties, 'DeveloperName').contentValue,
                            id: id,
                            typeElementId: manywho.utils.getObjectDataProperty(typeProperty.properties, 'TypeElementId').contentValue
                        }
                    ]
                }))
            }
        });
    }

    render() {
        manywho.log.info('Rendering Form: ' + this.props.id);

        if (this.props.isDesignTime)
            return null;

        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const state = manywho.state.getComponent(this.props.id, this.props.flowKey);

        let objectData = null;

        if (this.state.objectData)
            objectData = this.state.objectData;
        else if (model.objectData)
            objectData = Model.fromModel(model.ObjectData)[0];
        else
            objectData = this.state.type;

        return <div>
                <ObjectEditor objectData={objectData} onChange={this.onChange} flowKey={this.props.flowKey} authenticationToken={this.props.authenticationToken} tenantId={this.props.tenantId} isLoading={this.isLoading} />
                {React.createElement(manywho.component.getByName('wait'), { isVisible: state.loading }, null)}
            </div>
    }

}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
)(Form);
